The input parameter for the `updatePostedPositionProfile` mutation.
